import store from '../state';

/**
 * Used to return smtp driver name based on smtp driver value.
 * @param {number} driver smtp driver value.
 * @returns {string} returns smtp driver name.
*/
function getSmtpDriverName(driver) {
  switch (driver) {
    case 1:
      return `${store.getters.appName} SMTP`;
    case 2:
      return 'MailGun';
    case 3:
      return 'SendGrid';
    case 4:
      return 'SparkPost';
    case 5:
      return 'Amazon-SES';
    case 6:
      return 'Resend';
    case 7:
      return 'MailBaser';
    default:
      return 'N/A';
  }
}

export default getSmtpDriverName;
